import {
  useDeviceDefinitions,
  useDiagnosticDefinitions,
  useExamDefinitions,
  useProtocolDefinition,
  useTreatmentDefinitions,
} from "@repo/data-store";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { CatalogDefinition, ProtocolDefinitionEdit } from "@/features/catalog";
import {
  protocolDefinitionRouteId,
  protocolDefinitionUrlFromRouteId,
} from "@/features/catalog/lib/protocol-definition-route";

export const Route = createFileRoute("/catalog/protocols/$protocolId_/edit")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canRead("PlanDefinition")) throw redirect({ to: "/catalog/procedures" });
  },
  component: ProtocolEditRoute,
});

function ProtocolEditRoute() {
  const { protocolId } = Route.useParams();
  const { permissions } = Route.useRouteContext();
  const navigate = useNavigate();
  const definition = useProtocolDefinition(protocolDefinitionUrlFromRouteId(protocolId));
  const treatments = useTreatmentDefinitions({ availability: "Active" });
  const diagnostics = useDiagnosticDefinitions({ availability: "Active" });
  const examDefinitions = useExamDefinitions({ availability: "Active" });
  // Unfiltered: a device requirement is unpinned, so a procedure may name a kind
  // that has since been deactivated and its parameters still need answering.
  const deviceDefinitions = useDeviceDefinitions();
  const back = (url = definition?.definitionUrl) =>
    url
      ? navigate({ to: "/catalog/protocols/$protocolId", params: { protocolId: protocolDefinitionRouteId(url) } })
      : navigate({ to: "/catalog/procedures" });
  if (!definition) {
    return <CatalogDefinition.NotFound label="Protocol" backTo="/catalog/procedures" backLabel="Back to procedures" />;
  }
  return (
    <ProtocolDefinitionEdit
      definition={definition}
      procedureItems={treatments}
      diagnosticItems={diagnostics}
      examItems={examDefinitions}
      deviceDefinitionItems={deviceDefinitions}
      canEdit={permissions.canWrite("PlanDefinition")}
      onDone={back}
      onCancel={() => back()}
    />
  );
}
